import React, { useContext, useEffect, useState } from "react";
import LayoutOther from "./layout/Layout";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { ApplicationContext } from "../providers/ApplicationProvider";
import KytkaWhite from "../assets/images/logo-white.svg";
import polevka from "../assets/images/soup-min.jpg";
import predkrm from "../assets/images/predkrm-min.jpg";
import kureci from "../assets/images/kureci-min.jpg";
import veprove from "../assets/images/veprove-min.jpg";
import beef from "../assets/images/beef-min.jpg";
import dezerty from "../assets/images/dezert-min.jpeg";
import testovinygnocchi from "../assets/images/testoviny-min.jpg";
import priloha from "../assets/images/prilohy-min.jpg";
import salat from "../assets/images/salat-min.jpg";
import omackyimg from "../assets/images/omackyimg.jpg";
import grills from "../assets/images/grill.jpg";
import axios from "axios";
import { Fade } from "react-awesome-reveal";
import Loading from "./pages/Loading";
import ukrainian from "../assets/images/ukrajinske_jidla.jpg";
import specialities from "../assets/images/bramboraky.jpg";
import burgersimg from "../assets/images/burger.jpg";
import pizzasimg from "../assets/images/pizzas.jpg";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const Restaurant = () => {
  const [{ lang }] = useContext(ApplicationContext);
  const [isLoading, setIsLoading] = useState(true);
  const [menuData, setMenuData] = useState({
    daily: [],
    dailyPolevka: [],
    predrkm: [],
    polevky: [],
    salaty: [],
    deserty: [],
    testoviny: [],
    veprovemaso: [],
    hovezimaso: [],
    kurecimaso: [],
    prilohy: [],
    omacky: [],
    grill: [],
    dipy: [],
    specialitiesdishes: [],
    ukrainiandishes: [],
    pizzas: [],
    burgers: [],
  });

  const {
    daily,
    dailyPolevka,
    predrkm,
    polevky,
    salaty,
    deserty,
    testoviny,
    veprovemaso,
    hovezimaso,
    kurecimaso,
    prilohy,
    omacky,
    grill,
    dipy,
    specialitiesdishes,
    ukrainiandishes,
    pizzas,
    burgers,
  } = menuData;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let endpoints = [
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/0`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/1`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/2`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/3`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/4`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/5`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/6`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/7`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/8`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/9`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/12`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/18`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/10`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/19`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/23`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/24`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/25`,
      `${process.env.REACT_APP_BACKEND_URL}/restaurant/getByType/26`,
    ];

    setIsLoading(true);
    axios
      .all(
        endpoints.map((endpoint) =>
          axios.get(endpoint, {
            headers: {
              "Content-Type": "application/json",
            },
          })
        )
      )
      .then((data) => setFood(data))
      .catch((err) => {})
      .then(() => {
        setIsLoading(false);
      });
  }, []);

  const setFood = (data) => {
    setMenuData({
      daily: data[0].data,
      predrkm: data[1].data,
      polevky: data[2].data,
      deserty: data[9].data,
      kurecimaso: data[3].data,
      hovezimaso: data[5].data,
      veprovemaso: data[4].data,
      testoviny: data[6].data,
      salaty: data[7].data,
      prilohy: data[8].data,
      dailyPolevka: data[10].data,
      omacky: data[11].data,
      grill: data[12].data,
      dipy: data[13].data,
      specialitiesdishes: data[14].data,
      ukrainiandishes: data[15].data,
      pizzas: data[16].data,
      burgers: data[17].data,
    });
  };

  function renderDailyMenu(e) {
    var array = null;

    if (lang === "cs") {
      array = e.map((item) => (
        <>
          <div className="rest-text">
            <p className="name-head">
              <strong>{item.nameCS}</strong>
            </p>
            <p className="price">
              {item.amount} {item.amount.length > 1 ? "/" : ""}{" "}
              <strong>{item.price}&nbsp;Kč</strong>
            </p>
          </div>
          <div className="rest-text">
            <p className="rest-text-desc">{item.descriptionCS}</p>
          </div>
        </>
      ));
    } else if (lang === "de") {
      array = e.map((item) => (
        <>
          <div className="rest-text">
            <p className="name-head">
              <strong>{item.nameDE}</strong>
            </p>
            <p className="price">
              {item.amount} {item.amount.length > 1 ? "/" : ""}{" "}
              <strong>{item.price}&nbsp;Kč</strong>
            </p>
          </div>
          <div className="rest-text">
            <p className="rest-text-desc">{item.descriptionDE}</p>
          </div>
        </>
      ));
    } else if (lang === "en") {
      array = e.map((item) => (
        <>
          <div className="rest-text">
            <p className="name-head">
              <strong>{item.nameEN}</strong>
            </p>
            <p className="price">
              {item.amount} {item.amount.length > 1 ? "/" : ""}{" "}
              <strong>{item.price}&nbsp;Kč</strong>
            </p>
          </div>
          <div className="rest-text">
            <p className="rest-text-desc">{item.descriptionEN}</p>
          </div>
        </>
      ));
    }

    return array;
  }

  function renderMenu(e) {
    var array = "";
    if (lang === "cs") {
      array = e.map((item) => (
        <>
          <div className="menu-text">
            <p className="name-head">
              <strong>{item.nameCS}</strong>
            </p>
            <p className="price">
              {item.amount} {item.amount.length > 1 ? "/" : ""}{" "}
              <strong>{item.price}&nbsp;Kč</strong>
            </p>
          </div>
          <div className="menu-text">
            <p className="menu-text-desc">{item.descriptionCS}</p>
          </div>
        </>
      ));
    } else if (lang === "de") {
      array = e.map((item) => (
        <>
          <div className="menu-text">
            <p className="name-head">
              <strong>{item.nameDE}</strong>
            </p>
            <p className="price">
              {item.amount} {item.amount.length > 1 ? "/" : ""}{" "}
              <strong>{item.price}&nbsp;Kč</strong>
            </p>
          </div>
          <div className="menu-text">
            <p className="menu-text-desc">{item.descriptionDE}</p>
          </div>
        </>
      ));
    } else if (lang === "en") {
      array = e.map((item) => (
        <>
          <div className="menu-text">
            <p className="name-head">
              <strong>{item.nameEN}</strong>
            </p>
            <p className="price">
              {item.amount} {item.amount.length > 1 ? "/" : ""}{" "}
              <strong>{item.price}&nbsp;Kč</strong>
            </p>
          </div>
          <div className="menu-text">
            <p className="menu-text-desc">{item.descriptionEN}</p>
          </div>
        </>
      ));
    }

    return array;
  }

  function renderDailyCard() {
    return (
      <>
        <Row>
          <h3 className="text-center">
            {lang === "cs"
              ? "Denní menu"
              : lang === "en"
              ? "Daily menu"
              : "Menü des Tages"}
          </h3>
          <p className="text-center">
            <strong>11:00 - 14:00</strong>
          </p>
        </Row>
        <Row>
          <Col lg>
            <h4>
              {lang === "cs" ? "Polévky" : lang === "en" ? "soups" : "Suppen"}
            </h4>
            {renderDailyMenu(dailyPolevka)}
          </Col>
          <Col lg>
            <h4>
              {lang === "cs"
                ? "Hotová jídla"
                : lang === "en"
                ? "ready-made dishes"
                : "Fertiggerichte"}
            </h4>
            {renderDailyMenu(daily)}
          </Col>
        </Row>
      </>
    );
  }

  function renderDailyCardMobile() {
    return (
      <>
        <Row className="hotel-row">
          <Card>
            <CardBody>
              <Col lg>
                <h3>
                  {lang === "cs"
                    ? "Denní menu"
                    : lang === "en"
                    ? "Daily menu"
                    : "Menü des Tages"}
                </h3>
                <h4>Polévky</h4>
                {renderDailyMenu(dailyPolevka)}
                <h4>Hotová jídla</h4>
                {renderDailyMenu(daily)}
              </Col>
            </CardBody>
          </Card>
        </Row>
      </>
    );
  }
  if (isLoading) {
    return (
      <>
        <Loading />
      </>
    );
  } else if (!isLoading) {
    return (
      <>
        <Helmet>
          <title>Wellness Hotel Edelweiss | Restaurace Liberec, Česká kuchyně</title>
          <meta
            name="description"
            content="Restaurace Edelweiss v Liberci pod Ještědem. Tradiční česká kuchyně v moderním pojetí. Denní menu, obědy, večeře. Otevřeno i pro veřejnost."
          />
          <link rel="canonical" href="https://www.hoteledelweiss.cz/restaurant" />
          <meta property="og:title" content="Wellness Hotel Edelweiss | Restaurace Liberec" />
          <meta
            property="og:description"
            content="Restaurace Edelweiss v Liberci pod Ještědem. Tradiční česká kuchyně v moderním pojetí. Denní menu, obědy, večeře."
          />
          <meta property="og:url" content="https://www.hoteledelweiss.cz/restaurant" />
          <meta property="og:type" content="restaurant" />
          <meta
            property="og:image"
            content="https://hoteledelweiss.cz/static/media/restaurant-min.44204af3f5c4a5725a69.jpg"
          />
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "Restaurant",
                "name": "Restaurace Edelweiss",
                "image": "https://hoteledelweiss.cz/static/media/restaurant-min.44204af3f5c4a5725a69.jpg",
                "url": "https://www.hoteledelweiss.cz/restaurant",
                "telephone": "+420 777 336 810",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Za Domovem 333",
                  "addressLocality": "Liberec - Horní Hanychov",
                  "postalCode": "460 08",
                  "addressCountry": "CZ"
                },
                "servesCuisine": "Czech",
                "priceRange": "$$"
              }
            `}
          </script>
        </Helmet>
        <Fade>
          <LayoutOther>
            <div className="showcase-restaurant">
              <div className="showcase-content">
                <div className="showcase-hotel-table">
                  <Container>
                    <div className="welcome-text hotel-text col-md-8">
                      <h1>
                        {lang === "cs" ? "NAŠE RESTAURACE" : "RESTAURANT"}
                      </h1>
                      {lang === "cs" ? (
                        <>
                          <p>
                            Hotelová restaurace uspokojí náročné chutě každého,
                            kdo má rád českou kuchyni v&nbsp;moderním pojetí.
                            Pod taktovkou šéfkuchaře si hosté vychutnají pestré,
                            zdravé a&nbsp;přitom plnohodnotné snídaně, klasické
                            obědy i&nbsp;moderně připravenou českou večeři.
                          </p>
                          <p>
                            Restauraci pro třicet osob mohou navštívit
                            i&nbsp;hosté z&nbsp;venku. Náš tým rád připraví také
                            obchodní setkání, rodinné oslavy, svatby či firemní
                            teambuildingy.
                          </p>
                        </>
                      ) : lang === "en" ? (
                        <>
                          <p>
                            The hotel restaurant will satisfy the&nbsp;demanding
                            tastes of anyone who likes Czech cuisine
                            in&nbsp;a&nbsp;modern concept. Under the&nbsp;baton
                            of&nbsp;the&nbsp;chef, guests can enjoy
                            a&nbsp;varied, healthy yet full breakfast, classic
                            lunches and&nbsp;a&nbsp;modern Czech dinner.
                          </p>
                          <p>
                            The restaurant for thirty people can also be visited
                            by guests from outside. Our team will also be happy
                            to prepare business meetings, family celebrations,
                            weddings or corporate teambuilding.
                          </p>
                        </>
                      ) : (
                        <>
                          <p>
                            Das Hotelrestaurant befriedigt die anspruchsvollen
                            Geschmäcker aller Liebhaber der tschechischen Küche
                            in einem modernen Konzept. Unter der Leitung des
                            Küchenchefs können die Gäste ein
                            abwechslungsreiches, gesundes und vollwertiges
                            Frühstück, klassische Mittagessen und ein modernes
                            tschechisches Abendessen genießen.
                          </p>
                          <p>
                            Das Restaurant für dreißig Personen kann auch von
                            externen Gästen besucht werden. Unser Team bereitet
                            auch gerne Geschäftstreffen, Familienfeiern,
                            Hochzeiten oder Firmen-Teambuildings vor.
                          </p>
                        </>
                      )}
                      <p></p>
                      <Link to="/restaurant/menu/select">
                        <button className="rest-button">
                          {lang === "cs"
                            ? "MENU"
                            : lang === "en"
                            ? "MENU"
                            : "MENU"}
                        </button>
                      </Link>
                      <p>
                        <br></br>
                      </p>
                    </div>
                  </Container>
                  <img src={KytkaWhite} className="kytka-white" alt="kytka" />
                </div>
              </div>
            </div>
            {/*
            {lang === "cs" ? (
              <Container>
                <div className="akce-vecery-sil">
                  <Col align="center">
                    <h2 className="m-0">SVATOMARTINSKÉ MENU</h2>
                    <p className="text-center">09. - 11.11.2024</p>
                    <p>
                      Ochutnejte pravou svatomartinskou klasiku!<br></br>
                      Připravili jsme pro Vás speciální menu z těch
                      nejkvalitnějších surovin. Křupavá husa, domácí knedlíky,
                      červené zelí a mladé víno – to vše v jedinečné kombinaci.
                    </p>
                  </Col>
                  <Col align="center">
                    <a
                      href="https://hoteledelweiss.cz/Menu/svatomartinske_menu_2024.pdf"
                      target="_blank"
                      className="icon-text"
                    >
                      <button className="rest-button valentine mt-0 my-sm-2">
                        MENU
                      </button>
                    </a>
                  </Col>
                </div>
              </Container>
            ) : lang === "en" ? (
              <Container>
                <div className="akce-vecery-sil">
                  <Col align="center">
                    <h2 className="m-0">St. Martin's Day menu</h2>
                    <p className="text-center">09. - 11.11.2024</p>
                    <p>
                      Indulge in the traditional flavors of St. Martin's Day.
                      <br></br>
                      Our specially crafted menu showcases the finest
                      ingredients. Savor the delectable combination of crispy
                      goose, homemade dumplings, red cabbage, and young wine.
                    </p>
                  </Col>
                  <Col align="center">
                    <a
                      href="https://hoteledelweiss.cz/Menu/svatomartinske_menu_2024.pdf"
                      target="_blank"
                      className="icon-text"
                    >
                      <button className="rest-button valentine mt-0 my-sm-2">
                        MENU
                      </button>
                    </a>
                  </Col>
                </div>
              </Container>
            ) : (
              <Container>
                <div className="akce-vecery-sil">
                  <Col align="center">
                    <h2 className="m-0">Martinsgansl-Menü</h2>
                    <p className="text-center">09. - 11.11.2024</p>
                    <p>
                      Lassen Sie sich von den traditionellen Aromen des
                      Martinstags verführen. <br></br>
                      Unser sorgfältig zusammengestelltes Menü präsentiert die
                      feinsten Zutaten. Genießen Sie die köstliche Kombination
                      aus knuspriger Gans, hausgemachten Knödeln, Rotkohl und
                      jungem Wein.
                    </p>
                  </Col>
                  <Col align="center">
                    <a
                      href="https://hoteledelweiss.cz/Menu/svatomartinske_menu_2024.pdf"
                      target="_blank"
                      className="icon-text"
                    >
                      <button className="rest-button valentine mt-0 my-sm-2">
                        MENU
                      </button>
                    </a>
                  </Col>
                </div>
              </Container>
            )}*/}
            {/*
            {lang === "cs" ? (
              <Container>
                <div className="akce-vecery">
                  <Col align="center">
                    <h2 className="m-0">VALENTÝNSKÉ MENU</h2>
                    <p className="text-center">14.02.2024</p>
                    <p>
                      Přijďte rozzářit svá srdce a dejte si naše Valentýnské
                      menu, neboť staré rčení praví, že láska prochází žaludkem
                      a my v Hotel Edelweiss věříme, že je to pravda.
                    </p>
                  </Col>
                  <Col align="center">
                    <a
                      href="https://hoteledelweiss.cz/Menu/valentyn_menu.pdf"
                      target="_blank"
                      className="icon-text"
                    >
                      <button className="rest-button valentine mt-0 my-sm-2">
                        MENU
                      </button>
                    </a>
                  </Col>
                </div>
              </Container>
            ) : lang === "de" ? (
              <Container>
                <div className="akce-vecery">
                  <Col align="center">
                    <h2 className="m-0">VALENTINSMENÜ</h2>
                    <p className="text-center">14.02.2024</p>
                    <p>
                      Kommen Sie und bringen Sie Ihre Herzen zum Leuchten und
                      genießen Sie das Valentinstagsmenü, denn das alte
                      Sprichwort, dass Liebe durch den Magen geht, ist wahr und
                      wir im Hotel Edelweiss glauben an diese Weisheit.
                    </p>
                  </Col>
                  <Col align="center">
                    <a
                      href="https://hoteledelweiss.cz/Menu/valentyn_menu.pdf"
                      target="_blank"
                      className="icon-text"
                    >
                      <button className="rest-button valentine mt-0 my-sm-2">
                        MENU
                      </button>
                    </a>
                  </Col>
                </div>
              </Container>
            ) : (
              <Container>
                <div className="akce-vecery">
                  <Col align="center">
                    <h2 className="m-0">VALENTINE'S MENU</h2>
                    <p className="text-center">14.02.2024</p>
                    <p>
                      Come and light up your hearts and enjoy the Valentine's
                      Day menu, for the old saying is true that love goes
                      through the stomach and we in Hotel Edelweiss believe it
                      to be true.
                    </p>
                  </Col>
                  <Col align="center">
                    <a
                      href="https://hoteledelweiss.cz/Menu/valentyn_menu.pdf"
                      target="_blank"
                      className="icon-text"
                    >
                      <button className="rest-button valentine mt-0 my-sm-2">
                        MENU
                      </button>
                    </a>
                  </Col>
                </div>
              </Container>
            )}*/}
            <div className="restaurant-content-mobile">
              <div className="container restaurant-page">
                {renderDailyCardMobile()}
              </div>
            </div>
            <div className="restaurant-content-others">
              <div className="restaurant-page container">
                {renderDailyCard()}
              </div>
            </div>
            <div className="anchor" id="dailymenu"></div>
            <Container fluid className="well-rest rest-menu">
              <Row>
                <Col md={6} className="p-0 well-rest-card">
                  <div className="restaurant-text">
                    <h3>
                      {lang === "cs"
                        ? "Předkrmy"
                        : lang === "en"
                        ? "appetizers"
                        : "Vorspeisen"}
                      <span></span>
                    </h3>
                    {renderMenu(predrkm)}
                  </div>
                </Col>
                <Col md={6} className="p-0 m-0">
                  <img src={predkrm} alt="polévka" className="restaurant-img" />
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 m-0 order-5 order-md-1">
                  <img src={polevka} alt="předrkm" className="wellness-img" />
                </Col>
                <Col
                  md={6}
                  className="p-0 well-rest-card green order-1 order-md-5"
                >
                  <div className="wellness-text">
                    <h3>
                      {lang === "cs"
                        ? "polévky"
                        : lang === "en"
                        ? "soups"
                        : "Suppen"}
                    </h3>
                    {renderMenu(polevky)}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 well-rest-card">
                  <div className="restaurant-text">
                    <h3>
                      {lang === "cs"
                        ? "kuřecí maso"
                        : lang === "en"
                        ? "chicken meat"
                        : "Hähnchen"}
                      <span></span>
                    </h3>
                    {renderMenu(kurecimaso)}
                  </div>
                </Col>
                <Col md={6} className="p-0 m-0">
                  <img
                    src={kureci}
                    alt="kuřecí maso"
                    className="restaurant-img"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 m-0 order-5 order-md-1">
                  <img
                    src={veprove}
                    alt="vepřové maso"
                    className="wellness-img"
                  />
                </Col>
                <Col
                  md={6}
                  className="p-0 well-rest-card green order-1 order-md-5"
                >
                  <div className="wellness-text">
                    <h3>
                      {lang === "cs"
                        ? "vepřové maso"
                        : lang === "en"
                        ? "pork meat"
                        : "Schweinefleisch"}
                    </h3>
                    {renderMenu(veprovemaso)}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 well-rest-card">
                  <div className="restaurant-text">
                    <h3>
                      {lang === "cs"
                        ? "hovězí maso"
                        : lang === "en"
                        ? "beef meat"
                        : "Rindfleisch"}
                      <span></span>
                    </h3>
                    {renderMenu(hovezimaso)}
                  </div>
                </Col>
                <Col md={6} className="p-0 m-0">
                  <img
                    src={beef}
                    alt="hovězí maso"
                    className="restaurant-img"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 m-0 order-5 order-md-1">
                  <img
                    src={testovinygnocchi}
                    alt="těstoviny"
                    className="wellness-img"
                  />
                </Col>
                <Col
                  md={6}
                  className="p-0 well-rest-card green order-1 order-md-5"
                >
                  <div className="wellness-text">
                    <h3>
                      {lang === "cs"
                        ? "těstoviny"
                        : lang === "en"
                        ? "pasta"
                        : "Nudeln"}
                    </h3>
                    {renderMenu(testoviny)}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 well-rest-card">
                  <div className="restaurant-text">
                    <h3>
                      {lang === "cs"
                        ? "Speciality našeho podniku"
                        : lang === "en"
                        ? "our specialties"
                        : "Hausspezialitäten"}
                      <span></span>
                    </h3>
                    {renderMenu(specialitiesdishes)}
                  </div>
                </Col>
                <Col md={6} className="p-0 m-0">
                  <img
                    src={specialities}
                    alt="naše speciality"
                    className="restaurant-img"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 m-0 order-5 order-md-1">
                  <img
                    src={ukrainian}
                    alt="ukrajinská jídla"
                    className="wellness-img"
                  />
                </Col>
                <Col
                  md={6}
                  className="p-0 well-rest-card green order-1 order-md-5"
                >
                  <div className="wellness-text">
                    <h3>
                      {lang === "cs"
                        ? "Ukrajinská jídla"
                        : lang === "en"
                        ? "Ukrainian dishes"
                        : "ukrainische küche"}
                    </h3>
                    {renderMenu(ukrainiandishes)}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 well-rest-card">
                  <div className="restaurant-text">
                    <h3>
                      {lang === "cs"
                        ? "saláty"
                        : lang === "en"
                        ? "salads"
                        : "Salate"}
                      <span></span>
                    </h3>
                    {renderMenu(salaty)}
                  </div>
                </Col>
                <Col md={6} className="p-0 m-0">
                  <img src={salat} alt="salát" className="restaurant-img" />
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 m-0 order-5 order-md-1">
                  <img
                    src={priloha}
                    alt="restaurant"
                    className="wellness-img"
                  />
                </Col>
                <Col
                  md={6}
                  className="p-0 well-rest-card green order-1 order-md-5"
                >
                  <div className="wellness-text">
                    <h3>
                      {lang === "cs"
                        ? "přílohy"
                        : lang === "en"
                        ? "Side dishes"
                        : "Beilagen"}
                    </h3>
                    {renderMenu(prilohy)}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 well-rest-card">
                  <div className="restaurant-text">
                    <h3>
                      {lang === "cs"
                        ? "omáčky a dipy"
                        : lang === "en"
                        ? "sauces and dips"
                        : "Saucen und Dips"}
                      <span></span>
                    </h3>
                    {renderMenu(omacky)}
                  </div>
                </Col>
                <Col md={6} className="p-0 m-0">
                  <img
                    src={omackyimg}
                    alt="restaurant"
                    className="restaurant-img"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6} className="p-0 m-0 order-5 order-md-1">
                  <img
                    src={dezerty}
                    alt="restaurant"
                    className="restaurant-img"
                  />
                </Col>
                <Col
                  md={6}
                  className="p-0 well-rest-card green order-1 order-md-5"
                >
                  <div className="wellness-text">
                    <h3>
                      {lang === "cs"
                        ? "dezerty"
                        : lang === "en"
                        ? "desserts"
                        : "Nachspeisen"}
                      <span></span>
                    </h3>
                    {renderMenu(deserty)}
                  </div>
                </Col>
              </Row>
            </Container>
            
          </LayoutOther>
        </Fade>
      </>
    );
  }
};

export default Restaurant;
